import type { Portal } from "../lib/portal";

/** The one question only a platform admin is ever asked: which door. Rendered inline by
 *  the root gate in place of the app, never as a route, so nothing else is drawn first. */
export function Choose({ onChoose }: { onChoose: (portal: Portal) => void }) {
  return (
    <div className="min-h-screen grid place-items-center">
      <div className="w-[560px]">
        <img src="/humindly-logo.png" alt="Humindly" className="h-8 mx-auto mb-6" />
        <h1 className="text-[20px] font-extrabold tracking-tight text-center">Where to?</h1>
        <p className="text-muted text-[13px] mt-1 mb-6 text-center">You have two views. You will be asked each time you sign in, and can switch any time from the sidebar.</p>
        <div className="grid grid-cols-2 gap-3">
          <button className="card text-left hover:bg-tile transition-colors" onClick={() => onChoose("org")}>
            <div className="font-bold text-[15px]">My organisation →</div>
            <p className="text-muted text-[12.5px] mt-1">Humindly as a customer sees it: your people, connections and signals.</p>
          </button>
          <button className="card text-left hover:bg-tile transition-colors" onClick={() => onChoose("admin")}>
            <div className="font-bold text-[15px]">Humindly admin →</div>
            <p className="text-muted text-[12.5px] mt-1">Every organisation on the platform: what is connected, what we hold, what ran. Counts only.</p>
          </button>
        </div>
      </div>
    </div>
  );
}
